export enum EventEnum {
  OpenModal = 'MODAL_OPEN',
}

export enum ModalEnum {
  Faq = 'FAQ',
  IsSafe = 'IsSafe',
  WhatOpenBanking = 'WhatOb',
  WhoIsAccountScore = 'WhoIsAccountscore',
  PrivacyPolicy = 'Policy',
  TermsOfService = 'Terms',
  PrivacyNotice = 'Notice',
  Deny = 'Deny',
  AboutAccountScore = 'AboutAccountScore',
  ProvidingYourBankDetails = 'ProvidingYourBankDetails',
  Security = 'Security',
  NoCreditImpact = 'NoCreditImpact',
  NoBankAlert='NoBankAlert',
}

export enum ConfigType {
    SelectedBankWebHookEvent = 'SelectedBankWebHookEvent',
    SubmittedConsentsDetailsWebHookEvent = 'SubmittedConsentsDetailsWebHookEvent',
    ConsentsDeniedWebhook = 'ConsentsDeniedWebhook',
    SignUpFinishWebHook = 'SignUpFinishWebHook'
}

const invertedModalEnum = Object.keys(ModalEnum).reduce((c: any, n: any) => {
  c[(ModalEnum as any)[n]] = n;
  return c;
}, {});

// declare module 'vue/types/vue' {
//   interface Vue {
//     $bus: Vue;
//   }
// }
